// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TradeLinkHelp_wrapper__9xG6L {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1;
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz {
  background-color: #222121;
  border-radius: 12px;
  color: #dad6ce;
  max-width: 612px;
  width: 90%;
  padding: 20px;
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_title__lLhDX {
  font-size: 24px;
  color: #faf9f8;
  text-align: center;
  font-family: "Open Sans SemiBold";
  margin-bottom: 24px;
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_subtitle__ubLR- {
  font-family: "Open Sans Regular";
  font-size: 16px;
  margin-bottom: 16px;
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_list__NEymO .TradeLinkHelp_listItem__l5daP {
  display: flex;
  align-items: center;
  font-family: "Open Sans Regular";
  font-weight: 400;
  font-size: 16px;
  letter-spacing: -0.02em;
  color: #c2bdb2;
  margin-bottom: 8px;
  padding-left: 5px;
  position: relative;
  padding-left: 16px;
  margin-left: 16px;
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_list__NEymO .TradeLinkHelp_listItem__l5daP span {
  color: #ffffff;
  font-weight: 500;
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_list__NEymO .TradeLinkHelp_listItem__l5daP .TradeLinkHelp_listImage__nHijV {
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_listItem_down__zDpCP {
  font-family: "Open Sans Regular";
  font-weight: 400;
  font-size: 16px;
  letter-spacing: -0.02em;
  color: #c2bdb2;
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_btn__Uk8\\+g {
  display: flex;
  justify-content: end;
  margin-top: 20px;
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_btn__Uk8\\+g button {
  font-family: "Open Sans SemiBold";
  font-size: 16px;
  border-radius: 12px;
  background: #f2f740;
  text-transform: capitalize;
  color: #292621;
  cursor: pointer;
  width: 76px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_btn__Uk8\\+g button:hover {
  background-color: #f5f966;
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_btn__Uk8\\+g button:active {
  background-color: #e6eb3d;
}

@media (max-width: 850px) {
  .TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_subtitle__ubLR- {
    font-size: 16px;
  }
  .TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_list__NEymO .TradeLinkHelp_listItem__l5daP {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TradeLinkHelp/TradeLinkHelp.module.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;EACA,oCAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,OAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;AADF;AAGE;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;AADJ;AAGI;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;AADN;AAII;EACE,gCAAA;EACA,eAAA;EACA,mBAAA;AAFN;AAMM;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAJR;AAKQ;EACE,cAAA;EACA,gBAAA;AAHV;AAMQ;EACE,OAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AAJV;AAQI;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;AANN;AASI;EACE,aAAA;EACA,oBAAA;EACA,gBAAA;AAPN;AAQM;EACE,iCAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AANR;AAQQ;EACE,yBAAA;AANV;AAQQ;EACE,yBAAA;AANV;;AAaA;EAGM;IACE,eAAA;EAZN;EAgBM;IACE,eAAA;EAdR;AACF","sourcesContent":["@use 'assets/styles/global.scss' as *;\n\n.wrapper {\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 1;\n\n  .container {\n    background-color: #222121;\n    border-radius: 12px;\n    color: #dad6ce;\n    max-width: 612px;\n    width: 90%;\n    padding: 20px;\n\n    .title {\n      font-size: 24px;\n      color: #faf9f8;\n      text-align: center;\n      font-family: \"Open Sans SemiBold\";\n      margin-bottom: 24px;\n    }\n\n    .subtitle {\n      font-family: \"Open Sans Regular\";\n      font-size: 16px;\n      margin-bottom: 16px;\n    }\n\n    .list {\n      .listItem {\n        display: flex;\n        align-items: center;\n        font-family: \"Open Sans Regular\";\n        font-weight: 400;\n        font-size: 16px;\n        letter-spacing: -0.02em;\n        color: #c2bdb2;\n        margin-bottom: 8px;\n        padding-left: 5px;\n        position: relative;\n        padding-left: 16px;\n        margin-left: 16px;\n        span {\n          color: #ffffff;\n          font-weight: 500;\n        }\n\n        .listImage {\n          left: 0;\n          position: absolute;\n          top: 50%;\n          transform: translateY(-50%);\n        }\n      }\n    }\n    .listItem_down {\n      font-family: \"Open Sans Regular\";\n      font-weight: 400;\n      font-size: 16px;\n      letter-spacing: -0.02em;\n      color: #c2bdb2;\n    }\n\n    .btn {\n      display: flex;\n      justify-content: end;\n      margin-top: 20px;\n      button {\n        font-family: \"Open Sans SemiBold\";\n        font-size: 16px;\n        border-radius: 12px;\n        background: #f2f740;\n        text-transform: capitalize;\n        color: #292621;\n        cursor: pointer;\n        width: 76px;\n        height: 38px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        &:hover {\n          background-color: #f5f966;\n        }\n        &:active {\n          background-color: #e6eb3d;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .wrapper {\n    .container {\n      .subtitle {\n        font-size: 16px;\n      }\n\n      .list {\n        .listItem {\n          font-size: 14px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `TradeLinkHelp_wrapper__9xG6L`,
	"container": `TradeLinkHelp_container__ZzbUz`,
	"title": `TradeLinkHelp_title__lLhDX`,
	"subtitle": `TradeLinkHelp_subtitle__ubLR-`,
	"list": `TradeLinkHelp_list__NEymO`,
	"listItem": `TradeLinkHelp_listItem__l5daP`,
	"listImage": `TradeLinkHelp_listImage__nHijV`,
	"listItem_down": `TradeLinkHelp_listItem_down__zDpCP`,
	"btn": `TradeLinkHelp_btn__Uk8+g`
};
export default ___CSS_LOADER_EXPORT___;
